import { Directive, HostBinding, Input } from '@angular/core';

const MAX_COUNTER_VAL = 999;
const MAX_COUNTER_LABEL = '99+';
const PRIMARY_VARIANT = 'primary';

@Directive({
  selector: '[shrdUtcCountIndicator]'
})
export class CountIndicatorDirective {
  @Input() shrdUtcCountIndicator: number;
  @Input() shrdUtcCountIndicatorVertAlign: boolean;
  @Input() shrdUtcCountIndicatorInline: boolean;
  @Input() indicatorVariant: typeof PRIMARY_VARIANT;

  @HostBinding('class.indicator-scale-in')
  @Input()
  scaleIn = false;

  @HostBinding('class.icon-count-indicator')
  get isVisible(): boolean {
    return this.shrdUtcCountIndicator > 0;
  }

  @HostBinding('class.primary')
  get isPrimary(): boolean {
    return this.isVisible && this.indicatorVariant === PRIMARY_VARIANT;
  }

  @HostBinding('attr.data-count-indicator')
  public get counter(): string | number {
    const counter = this.shrdUtcCountIndicator || null;
    return counter > MAX_COUNTER_VAL ? MAX_COUNTER_LABEL : counter;
  }

  @HostBinding('class.icon-count-indicator-vertical-align')
  get isVerticalAlign(): boolean {
    return this.shrdUtcCountIndicatorVertAlign;
  }

  @HostBinding('class.icon-count-indicator-inline')
  get isInline(): boolean {
    return this.shrdUtcCountIndicatorInline;
  }
}
